module.exports = __webpack_public_path__ + "static/img/ctMyAnalysis1.937bb338.png";